import React, { useState, useEffect } from "react";
import {
  Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Table
} from "reactstrap";
import { rightsidebar, getDocumentsById, getFileDoc, getFileDetail } from "../../../../context/actions/document";
import LoaderUI from '../../../../components/common/loader';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, pagination } from "../../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { resetAutoSaveData } from "../../../../context/actions/tempAction";
import { getFileSetting } from "../../../../context/actions/fileSetting";


toast.configure();

const AutoSaveDataModal = ({ autoSaveData, title, showModel, setShowModel, _toggle, addOperator, updateOperator, operatorDetail, locations, lodder }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [paginations] = useState(pagination.limit);
  const [disable, setDisable] = useState(false)
  const [fileClicked, setFileClicked] = useState(false)


  const close = () => {
    dispatch(resetAutoSaveData())
    setShowModel(false)
  };


  const viewFile = (item) => {

    // console.log('client wall running 123 ') delete this comment
    setFileClicked(item._id)
    dispatch(getFileDetail({ docId: item.docId._id, Au: null, pageNumber: 1, }, res => {
      if (res.deleted) {
        let data = autoSaveData.filter((data) => {
          return data._id != item._id
        })
        dispatch({ type: "SET_AUTOSAVE_DATA", data: data })
        toast.success("The file is already archived", toasterConfig);
        history.push("/documents");
        setFileClicked(false)
        // toast.success("The file is already archived", toasterConfig);
      }
      else {
        let tab = "C"
        if (item.mode == "autosave_V")
          tab = "V"

        let data = autoSaveData.filter((data) => {
          return data._id != item._id
        })

        dispatch(getDocumentsById({ folder: item.docId.folder, limit: paginations, page: 1, fields: '_id', filter: item.docId._id }, ((result) => {
        })));
        dispatch(getFileSetting(((result) => {
        })));
        dispatch(
          getFileDoc({ docId: item.docId._id, Au: null, pageNumber: 1, version: item.version }, (result) => {
            if (Object.keys(result).length) {
              localStorage.setItem('version', item.version)
              window.open(`/documentDetail`, "_blank")
              dispatch({ type: "SET_AUTOSAVE_DATA", data: data })
              dispatch(rightsidebar(tab));
              // setDisable(false)
              setFileClicked(false)
            }
            else { //else condition is used to check if response is present or not. This condititon comes to play is the file is archived. 
              window.open(`/documents`, "_blank");

              toast.success("The file is already archived", toasterConfig);
              setFileClicked(false)
            }
          })
        )
      }

    }))
    // }

    // }
    //   ))

  };

  return (
    <>
      <Modal isOpen={showModel}
        backdrop="static">
        <ModalHeader>
          {title}
          While you were away following files versions have been created
        </ModalHeader>
        <ModalBody>
          <Table style={{ maxHeight: "30px" }}>
            <thead>
              <tr>
                <th>Files</th>
                <th>Version</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {autoSaveData && autoSaveData.map((item) => {
                if (!item.docId.deleted)
                  return (
                    <tr>
                      <td>{item.docId.name}</td>
                      <td>{item.version}</td>
                      <td>

                        <Button disabled={fileClicked === item._id} color="link" onClick={() => viewFile(item)} ><FontAwesomeIcon icon={faEye} /> </Button>

                      </td>
                    </tr>
                  )
              })}

            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          {/* <Button color="link" onClick={toggle} disabled={disable} className="cancel-btn">
            View
          </Button> */}
          <Button
            disabled={disable}
            color="secondary"
            onClick={close}
          >
            Close
          </Button>
        </ModalFooter>

      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default AutoSaveDataModal;
